import { render, staticRenderFns } from "./ParentVerticalMenuButton.vue?vue&type=template&id=b74ecc90&scoped=true&"
import script from "./ParentVerticalMenuButton.vue?vue&type=script&lang=js&"
export * from "./ParentVerticalMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./ParentVerticalMenuButton.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ParentVerticalMenuButton.vue?vue&type=style&index=1&id=b74ecc90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74ecc90",
  null
  
)

export default component.exports